import React, { useState } from 'react';
import { PrivacyPolicyModal } from './PrivacyPolicyModal';
import { TermsModal } from './TermsModal';

export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);

  return (
    <>
      <footer className="bg-white border-t border-gray-200 py-4 mt-8">
        <div className="max-w-[1920px] mx-auto px-4">
          <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-600">
            <button
              onClick={() => setShowTerms(true)}
              className="hover:text-blue-500 transition-colors"
            >
              Regulamin
            </button>
            <span className="text-gray-300">|</span>
            <button
              onClick={() => setShowPrivacy(true)}
              className="hover:text-blue-500 transition-colors"
            >
              Polityka prywatności
            </button>
          </div>
        </div>
      </footer>

      <PrivacyPolicyModal
        isOpen={showPrivacy}
        onClose={() => setShowPrivacy(false)}
      />

      <TermsModal
        isOpen={showTerms}
        onClose={() => setShowTerms(false)}
      />
    </>
  );
}